import { getGlobal } from 'lib/contentful';
import { reformatLocaleToContentfulLocale } from 'lib/utils/helpers';
import Layout from 'components/layout';
import RegisterSection from 'components/account/registerSection';
import { useSalons } from 'hooks';

export const Register = ({ previewData, locale, globalModules }) => {
  useSalons(locale);

  return (
    <Layout locale={locale} previewData={previewData} globalModules={globalModules} cookieBar>
      <RegisterSection
        locale={locale}
        registerpage={globalModules?.registerpage}
        registermessages={globalModules.registermessages}
      />
    </Layout>
  );
};

export async function getStaticProps({ previewData = null, locale }) {
  const globalModules = await getGlobal(
    [
      'registerpage',
      'registermessages',
      'announcement-bar',
      'cookies',
      'firstcountryselectorlocales',
    ],
    reformatLocaleToContentfulLocale(locale)
  );

  const { localesWithWebshop } = globalModules?.settings;

  if (!localesWithWebshop.onOrOff)
    return {
      notFound: true,
    };

  return {
    props: { previewData, locale, globalModules },
  };
}

export default Register;
